<template>
  <div class="product-form-container">
    <!-- 全局加载遮罩层 -->
    <div class="loading-mask" v-if="loading">
      <div class="loading-spinner"></div>
    </div>
    <!-- 表单主体 -->
    <div class="form-wrapper" style="position: relative">
      <button
        class="btn publish-btn"
        style="position: absolute; right: 0"
        @click="Drafts"
      >
        草稿箱
      </button>
      <h1 class="panel-title">官方产样发布</h1>
      <!-- 左侧表单区域 -->
      <div class="form-left">
        <!-- 样衣编号 -->
        <div class="form-item single-item">
          <label>样衣编号:</label>
          <input
            style="width: 150px"
            type="text"
            v-model="formData.productCode"
            placeholder="请输入样衣编号"
            disabled
          />
          <label>类别:</label>
          <el-select
            v-model="formData.categoryId"
            placeholder="请选择类别"
            multiple
            collapse-tags
            clearable
            style="padding: 12px"
            :style="{ borderBottom: 'none' }"
          >
            <el-option
              v-for="option in leilist"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            />
          </el-select>
        </div>
        <!-- 面料信息分组 -->
        <div class="fabric-group">
          <div class="group-title">面料信息：</div>
          <div class="form-item single-item">
            <label>品名/编号:</label>
            <el-select
              filterable
              v-model="formData.productpm"
              placeholder="请选择品名编号"
              @change="watchs(formData.productpm)"
              style="padding: 12px"
              :style="{ borderBottom: 'none' }"
            >
              <el-option
                v-for="option in lists"
                :key="option.id"
                :label="option.name"
                :value="option.name"
              />
            </el-select>
          </div>
          <!-- 两行两列布局：幅宽/克重、成份/类别 -->
          <div class="form-row">
            <div class="form-item">
              <label>幅宽:</label>
              <input disabled type="text" v-model="formData.width" />
            </div>
            <div class="form-item">
              <label>克重:</label>
              <input disabled type="text" v-model="formData.weight" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>成份:</label>
              <input disabled type="text" v-model="formData.composition" />
            </div>
            <div class="form-item">
              <label>规格:</label>
              <input disabled type="text" v-model="formData.specification" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>量化:</label>
              <input disabled type="text" v-model="formData.quantify" />
            </div>
            <div class="form-item">
              <label>备注:</label>
              <input disabled type="text" v-model="formData.remark" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-item">
              <label>纱支:</label>
              <input disabled type="text" v-model="formData.yarnCount" />
            </div>
            <div class="form-item">
              <label>密度:</label>
              <input disabled type="text" v-model="formData.density" />
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧上传区域 -->
      <div class="form-right">
        <div class="upload-section">
          <h4>
            封面图（图片比例宽高3:4，单张图片不能超过1MB，<span
              style="color: #ffae00"
              >点击图片可标记标签</span
            >）
          </h4>
          <div class="upload-boxes">
            <div
              class="upload-box"
              :key="`cover-1`"
              @click="handleUpload('cover', 1)"
            >
              <span v-show="!getImagePreviewUrl(`cover-1`)">+</span>
              <img
                v-if="getImagePreviewUrl(`cover-1`)"
                :src="getImagePreviewUrl(`cover-1`)"
                alt="封面图"
                class="uploaded-img"
                @click.stop="openCoverAnnotate"
              />
              <div
                v-if="isNeedReUpload(`cover-1`)"
                style="
                  color: #f56c6c;
                  font-size: 12px;
                  text-align: center;
                  position: absolute;
                  bottom: 4px;
                  left: 0;
                  right: 0;
                "
              >
                需重新上传
              </div>
              <div
                class="img-delete-btn"
                @click.stop="handleDeleteImage('cover', 1)"
                v-if="getImagePreviewUrl(`cover-1`)"
              >
                ×
              </div>
            </div>
          </div>
        </div>
        <!-- 详情图上传 -->
        <div class="upload-section">
          <h4>详情图(上限5张，单张图片不能超过1MB)</h4>
          <div class="upload-container">
            <div
              v-if="getEffectiveFileCount('detail') < 5"
              class="upload-box add-btn"
              @click="handleUpload('detail', getNextUploadIndex('detail'))"
            >
              <span>+</span>
            </div>
            <div ref="detailWrapRef" class="img-show-wrap">
              <div
                class="upload-box img-item"
                v-for="key in getAllImageKeys('detail')"
                :key="key"
                :data-key="key"
              >
                <img
                  v-if="getImagePreviewUrl(key)"
                  :src="getImagePreviewUrl(key)"
                  alt="详情图"
                  class="uploaded-img"
                />
                <div
                  v-if="isNeedReUpload(key)"
                  style="
                    color: #f56c6c;
                    font-size: 12px;
                    text-align: center;
                    position: absolute;
                    bottom: 4px;
                    left: 0;
                    right: 0;
                  "
                >
                  需重新上传
                </div>
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('detail', key.split('-')[1])"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 电子色卡上传 -->
        <div class="upload-section">
          <h4>电子色卡(上限5张，单张图片不能超过1.3MB)</h4>
          <div class="upload-container">
            <div
              v-if="getEffectiveFileCount('color') < 5"
              class="upload-box add-btn"
              @click="handleUpload('color', getNextUploadIndex('color'))"
            >
              <span>+</span>
            </div>
            <div ref="colorWrapRef" class="img-show-wrap">
              <div
                class="upload-box img-item"
                v-for="key in getAllImageKeys('color')"
                :key="key"
                :data-key="key"
              >
                <img
                  v-if="getImagePreviewUrl(key)"
                  :src="getImagePreviewUrl(key)"
                  alt="电子色卡"
                  class="uploaded-img"
                />
                <div
                  v-if="isNeedReUpload(key)"
                  style="
                    color: #f56c6c;
                    font-size: 12px;
                    text-align: center;
                    position: absolute;
                    bottom: 4px;
                    left: 0;
                    right: 0;
                  "
                >
                  需重新上传
                </div>
                <div
                  class="img-delete-btn"
                  @click.stop="handleDeleteImage('color', key.split('-')[1])"
                >
                  ×
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标题和正文输入区 -->
      <div class="textarea-section">
        <div class="textarea-item">
          <label>标题</label>
          <textarea
            v-model="formData.title"
            maxlength="45"
            placeholder="请输入标题,字数不能超过45个字"
          ></textarea>
        </div>
        <div class="textarea-item">
          <label>正文</label>
          <textarea
            v-model="formData.content"
            placeholder="请输入正文,字数不能超过150个字"
            rows="6"
            maxlength="150"
          ></textarea>
        </div>
      </div>
      <div class="btn-group">
        <button
          class="btn publish-btn"
          @click="handlePublish(0)"
          :disabled="loading"
        >
          发布
        </button>
        <button class="btn save-btn" @click="handlePublish(1)">暂存离开</button>
      </div>
      <!-- 全局隐藏file输入框，不再动态创建DOM -->
      <div class="global-file-inputs" style="display: none">
        <input
          type="file"
          ref="coverFileInput1"
          class="file-input"
          accept="image/*"
          @change="(e) => handleFileChange('cover', 1, e)"
        />
        <!-- detail 加上 multiple -->
        <template v-for="idx in 5" :key="`detail-${idx}`">
          <input
            type="file"
            :ref="`detailFileInput${idx}`"
            class="file-input"
            accept="image/*"
            multiple
            @change="(e) => handleFileChange('detail', idx, e)"
          />
        </template>
        <!-- color 加上 multiple -->
        <template v-for="idx in 5" :key="`color-${idx}`">
          <input
            type="file"
            :ref="`colorFileInput${idx}`"
            class="file-input"
            accept="image/*"
            multiple
            @change="(e) => handleFileChange('color', idx, e)"
          />
        </template>
      </div>
    </div>
  </div>
  <!-- 封面图放大标注弹窗【修改版：右侧坐标列表】 -->
  <el-dialog
    v-model="coverAnnotateVisible"
    title="封面图标注"
    width="90%"
    append-to-body
    @closed="clearCanvasInstance"
  >
    <div style="display: flex; gap: 16px">
      <!-- 左侧画布区域 -->
      <div
        ref="canvasWrapRef"
        class="canvas-wrap"
        style="
          flex: 1;
          height: 600px;
          overflow: hidden;
          position: relative;
          background: #f5f5f5;
        "
      >
        <canvas ref="coverCanvas" @click="handleCanvasClick"></canvas>
        <div
          v-if="coverMarkList.length"
          style="
            position: absolute;
            top: 8px;
            left: 8px;
            background: rgba(0, 0, 0, 0.55);
            color: #fff;
            font-size: 12px;
            padding: 4px 8px;
            border-radius: 4px;
            pointer-events: none;
          "
        >
          已标注 {{ coverMarkList.length }} 个点
        </div>
      </div>
      <!-- 右侧：标注类型 + 坐标列表面板 -->
      <div
        style="
          width: 260px;
          flex-shrink: 0;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
          padding: 12px;
          display: flex;
          flex-direction: column;
        "
      >
        <div style="margin-bottom: 12px">
          <div style="font-size: 14px; margin-bottom: 8px">选择标注类型</div>
          <el-radio-group v-model="currentMarkType">
            <el-radio label="fabric">面料供应点</el-radio>
            <el-radio label="accessory">辅料供应点</el-radio>
          </el-radio-group>
        </div>
        <div style="flex: 1; overflow: auto">
          <div style="font-size: 14px; margin-bottom: 8px; font-weight: 500">
            标注坐标列表
          </div>
          <div
            v-if="!coverMarkList.length"
            style="color: #999; font-size: 12px"
          >
            暂无标注点
          </div>
          <div
            v-for="(item, idx) in coverMarkList"
            :key="idx"
            style="
              padding: 6px 0;
              border-bottom: 1px solid #eee;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="font-size: 12px">
              <span
                >{{ idx + 1 }}.
                {{ item.type === "fabric" ? "面料供应点" : "辅料供应点" }}</span
              >
              <br />
              <span style="color: #666">X:{{ item.x }} Y:{{ item.y }}</span>
            </div>
            <el-button
              size="small"
              type="danger"
              text
              @click="removeSingleMark(idx)"
              >删除</el-button
            >
          </div>
        </div>
        <div style="margin-top: 12px; display: flex; gap: 8px">
          <el-button size="small" @click="clearCoverMarks">清空全部</el-button>
          <el-button
            size="small"
            class="btn publish-btn"
            @click="coverAnnotateVisible = false"
            >确定保存</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="annotate-toolbar"
      style="margin-top: 12px; display: flex; gap: 10px; align-items: center"
    ></div>
  </el-dialog>
  <Drafts
    ref="draftComponent"
    :draft-list="Draftslist"
    @fill-draft="onFillDraft"
    @refresh-draft="Drafts"
  />
</template>
<script>
import { ElSelect, ElOption, ElRadioGroup, ElRadio } from "element-plus";
import Drafts from "@/components/Drafts/Drafts.vue";
import Sortable from "sortablejs";
export default {
  name: "ProductForm",
  components: {
    Drafts,
    ElSelect,
    ElOption,
    ElRadioGroup,
    ElRadio,
  },
  data() {
    return {
      Draftslist: [],
      lists: [],
      MAX_COVER_SIZE: 1024 * 1024,
      MAX_IMG_SIZE: 1024 * 1024,
      MAX_COLORCARD_SIZE: 1.3 * 1024 * 1024,
      MAX_DETAIL_COUNT: 5,
      MAX_COLOR_COUNT: 5,
      leilist: [],
      loading: false,
      formData: {
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        colorCardCode: "",
        title: "",
        content: "",
        productpm: "",
        specification: "",
        yarnCount: "",
        density: "",
        quantify: "",
        remark: "",
        flag: 0,
        coverMarks: [],
      },
      uploadFiles: {
        "cover-1": null,
      },
      previewUrls: {},
      uploadMaxIndex: {
        detail: 0,
        color: 0,
        cover: 1,
      },
      imgBase64Cache: {},
      sortableIns: {
        detail: null,
        color: null,
      },
      bh: "",
      username: "",
      sjname: "",
      // 封面原图宽高
      coverImageWidth: null,
      coverImageHeight: null,
      // 封面标注新增
      coverAnnotateVisible: false,
      coverImgObj: null,
      coverScale: 1,
      coverTranslateX: 0,
      coverTranslateY: 0,
      coverIsDragging: false,
      coverLastX: 0,
      coverLastY: 0,
      coverMarkList: [],
      currentMarkType: "fabric", // 默认面料供应点
      // ===== 草稿复用图片（新增） =====
      isDraftMode: false, // 当前是否处于「草稿加载」模式
      draftImages: {}, // 草稿已有图片信息 { key: { id, url, type } }
      proid: "", //草稿id
    };
  },
  watch: {
    formData: {
      handler() {
        this.saveLocalCache();
      },
      deep: true,
    },
    imgBase64Cache: {
      handler() {
        this.saveLocalCache();
      },
      deep: true,
    },
    uploadMaxIndex: {
      handler() {
        this.saveLocalCache();
      },
      deep: true,
    },
    coverMarkList: {
      handler(val) {
        this.formData.coverMarks = JSON.parse(JSON.stringify(val));
        this.saveLocalCache();
      },
      deep: true,
    },
  },
  mounted() {
    this.getcp();
    this.getList().then(() => {
      this.restoreFormData();
      this.$nextTick(() => {
        this.initSortable();
      });
    });
  },
  beforeUnmount() {
    this.clearPreviewUrls();
    Object.values(this.sortableIns).forEach((ins) => {
      if (ins) ins.destroy();
    });
    this.clearCanvasInstance();
  },
  methods: {
    saveLocalCache() {
      const cacheData = {
        formData: { ...this.formData },
        imgBase64Cache: { ...this.imgBase64Cache },
        uploadMaxIndex: { ...this.uploadMaxIndex },
      };
      sessionStorage.setItem("productFormAutoCache", JSON.stringify(cacheData));
    },
    restoreFormData() {
      this.getbh();
      const cacheStr = sessionStorage.getItem("productFormAutoCache");
      if (!cacheStr) return;
      try {
        const cache = JSON.parse(cacheStr);
        if (cache.formData) {
          Object.keys(cache.formData).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
              this.formData[key] = cache.formData[key] || "";
            }
          });
          if (
            Array.isArray(cache.formData.coverMarks) &&
            cache.formData.coverMarks.length
          ) {
            this.coverMarkList = JSON.parse(
              JSON.stringify(cache.formData.coverMarks)
            );
          } else {
            this.coverMarkList = [];
          }
        }
        this.imgBase64Cache = cache.imgBase64Cache || {};
        this.uploadMaxIndex = cache.uploadMaxIndex || {
          detail: 0,
          color: 0,
          cover: 1,
        };
        this.uploadFiles = { "cover-1": null };
      } catch (e) {
        console.warn("本地缓存解析失败", e);
        sessionStorage.removeItem("productFormAutoCache");
      }
    },
    clearLocalCache() {
      sessionStorage.removeItem("productFormAutoCache");
    },
    async Drafts() {
      const sendata = {
        currentPage: 1,
        pageSize: 50,
      };
      const res = await this.$api.Operation.UserProductlaunch.cgx(sendata);
      if (res.data.code == "200") {
        this.Draftslist = res.data.data.list;
        console.log(this.Draftslist, "返回的草稿箱列表是什么格式");
        this.$refs.draftComponent.open();
      } else {
        this.$message.error("网络错误");
        this.Draftslist = [];
      }
    },
    // ========== 草稿加载：复用后端已有图片，不强制重传 ==========
    onFillDraft(draftData, imageData) {
      this.proid = draftData.proid;
      // 1. 回填表单文字
      Object.keys(draftData).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
          this.formData[key] = draftData[key];
        }
      });

      // 2. 清空当前临时上传状态，进入草稿模式
      this.resetFormImageOnly();
      this.isDraftMode = true;
      this.draftImages = {};
      this.previewUrls = {};
      this.imgBase64Cache = {};

      const fixUrl = (u) =>
        u && !/^https?:\/\//i.test(u) ? `https://${u}` : u;

      // ---- 封面 ----
      if (imageData.coverUrl) {
        const key = "cover-1";
        const url = fixUrl(imageData.coverUrl);
        this.previewUrls[key] = url;
        this.imgBase64Cache[key] = "draft-preview-placeholder";
        this.draftImages[key] = {
          id: imageData.coverId || "",
          url,
          type: "cover",
        };
        const img = new Image();
        img.src = url;
        img.onload = () => {
          this.coverImageWidth = img.width;
          this.coverImageHeight = img.height;
        };
      }

      // ---- 详情图 ----
      let maxDetailIdx = 0;
      const detailList = (imageData.particularsList || [])
        .slice()
        .sort((a, b) => a.sort - b.sort);
      detailList.forEach((item, idx) => {
        const index = idx + 1;
        const key = `detail-${index}`;
        const url = fixUrl(item.url);
        this.previewUrls[key] = url;
        this.imgBase64Cache[key] = "draft-preview-placeholder";
        this.draftImages[key] = { id: item.id || "", url, type: "detail" };
        maxDetailIdx = index;
      });
      this.uploadMaxIndex.detail = maxDetailIdx;

      // ---- 色卡 ----
      let maxColorIdx = 0;
      const colorList = (imageData.colorcardList || [])
        .slice()
        .sort((a, b) => a.sort - b.sort);
      colorList.forEach((item, idx) => {
        const index = idx + 1;
        const key = `color-${index}`;
        const url = fixUrl(item.url);
        this.previewUrls[key] = url;
        this.imgBase64Cache[key] = "draft-preview-placeholder";
        this.draftImages[key] = { id: item.id || "", url, type: "color" };
        maxColorIdx = index;
      });
      this.uploadMaxIndex.color = maxColorIdx;

      // ---- 封面标注 ----
      if (Array.isArray(imageData.coverMarks)) {
        this.coverMarkList = JSON.parse(JSON.stringify(imageData.coverMarks));
        this.formData.coverMarks = JSON.parse(
          JSON.stringify(imageData.coverMarks)
        );
      } else {
        this.coverMarkList = [];
        this.formData.coverMarks = [];
      }

      this.$message.success("草稿已加载");
      this.$nextTick(() => {
        Object.values(this.sortableIns).forEach((ins) => ins?.destroy());
        this.initSortable();
      });
    },
    resetFormImageOnly() {
      this.clearPreviewUrls();
      this.uploadFiles = { "cover-1": null };
      this.uploadMaxIndex = { detail: 0, color: 0, cover: 1 };
      this.previewUrls = {};
      this.imgBase64Cache = {};
      this.coverImageWidth = null;
      this.coverImageHeight = null;
      this.isDraftMode = false;
      this.draftImages = {};
    },
    async getbh() {
      const res = await this.$api.Operation.UserProductlaunch.bhget({});
      console.log(res.data.data);
      this.formData.productCode = res.data.data;
    },
    async getcp() {
      const sendata = `name=${encodeURIComponent(
        ""
      )}&memberName=${encodeURIComponent(
        ""
      )}&memberProductName=${encodeURIComponent("")}`;
      const res = await this.$api.Operation.Baseproduct.get(sendata);
      if (res.data.code == "200") {
        this.lists = res.data.data.list;
        console.log(this.lists, "返回的列表是什么格式");
      } else {
        this.$message.error("网络错误");
        this.lists = [];
      }
    },
    watchs(item) {
      const cpname = item;
      const itemlist = this.lists.filter((item) => item.name == cpname);
      console.log(itemlist[0], "我返回的备注为空?");
      this.formData.width = itemlist[0].width;
      this.formData.weight = itemlist[0].weight;
      this.formData.composition = itemlist[0].ingredients;
      this.formData.quantify = itemlist[0].quantify;
      this.formData.remark = itemlist[0].remark;
      this.formData.yarnCount = itemlist[0].yarnCount;
      this.formData.density = itemlist[0].density;
      this.formData.specification = itemlist[0].specification;
    },
    initSortable() {
      const detailEl = this.$refs.detailWrapRef;
      const colorEl = this.$refs.colorWrapRef;
      const createSort = (el, type) => {
        if (!el) return;
        this.sortableIns[type] = new Sortable(el, {
          animation: 150,
          ghostClass: "sort-ghost",
          filter: ".img-delete-btn",
          onEnd: (evt) => {
            const itemNodes = Array.from(evt.to.querySelectorAll(".img-item"));
            const newOrderKeys = itemNodes.map((node) => node.dataset.key);
            const newUploadFiles = {};
            newOrderKeys.forEach((key) => {
              if (this.uploadFiles[key]) {
                newUploadFiles[key] = this.uploadFiles[key];
              }
            });
            Object.keys(this.uploadFiles).forEach((k) => {
              if (!k.startsWith(type + "-")) {
                newUploadFiles[k] = this.uploadFiles[k];
              }
            });
            this.uploadFiles = newUploadFiles;
          },
        });
      };
      createSort(detailEl, "detail");
      createSort(colorEl, "color");
    },
    getEffectiveFileCount(type) {
      let count = 0;
      Object.keys(this.uploadFiles).forEach((key) => {
        if (key.startsWith(`${type}-`) && this.uploadFiles[key]) count++;
      });
      Object.keys(this.imgBase64Cache).forEach((key) => {
        if (
          key.startsWith(`${type}-`) &&
          this.imgBase64Cache[key] &&
          !this.uploadFiles[key]
        )
          count++;
      });
      return count;
    },
    // 判断单张图片是否需要重新上传（草稿已有图片不算）
    isNeedReUpload(key) {
      return (
        this.imgBase64Cache[key] &&
        !this.uploadFiles[key] &&
        !this.draftImages[key]
      );
    },
    checkNeedReUpload() {
      // 草稿模式：已有图片是后端资源，直接放行
      if (this.isDraftMode) return false;

      const allKeys = new Set();
      Object.keys(this.uploadFiles).forEach((key) => allKeys.add(key));
      Object.keys(this.imgBase64Cache).forEach((key) => allKeys.add(key));
      for (const key of allKeys) {
        if (this.imgBase64Cache[key] && !this.uploadFiles[key]) {
          return true;
        }
      }
      return false;
    },
    async getList() {
      try {
        const sendata = {};
        const res = await this.$api.System.ProductCategory.get(sendata);
        if (res.data.code == 200) {
          this.leilist = res.data.data.list;
        } else {
          this.$message.error("获取类别列表失败");
          this.leilist = [];
        }
      } catch (error) {
        console.error("获取类别列表异常：", error);
        this.$message.error("网络错误，获取类别列表失败");
        this.leilist = [];
      }
    },
    handleUpload(type, index) {
      if (index === -1) {
        this.$message.error("图片已达上限5张");
        return;
      }
      const refName = `${type}FileInput${index}`;
      let fileInput = this.$refs[refName];
      if (Array.isArray(fileInput)) fileInput = fileInput[0];
      if (!fileInput) {
        this.$message.error("上传组件异常，请刷新页面重试");
        console.error("找不到ref", refName);
        return;
      }
      fileInput.click();
    },
    handleFileChange(type, index, e) {
      const fileList = Array.from(e.target.files);
      if (!fileList.length) return;
      if (type === "cover") {
        const file = fileList[0];
        if (!file.type.startsWith("image/")) {
          this.$message.error("请选择图片格式的文件！");
          e.target.value = "";
          return;
        }
        let limitSize = this.MAX_COVER_SIZE;
        let errMsg = "图片大小不能超过1MB";
        if (file.size > limitSize) {
          this.$message.error(errMsg);
          e.target.value = "";
          return;
        }
        const key = `${type}-${index}`;
        this.uploadFiles[key] = file;
        delete this.imgBase64Cache[key];
        this.previewUrls[key] = URL.createObjectURL(file);
        // 读取原图宽高
        const img = new Image();
        img.src = this.previewUrls[key];
        img.onload = () => {
          this.coverImageWidth = img.width;
          this.coverImageHeight = img.height;
        };
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgBase64Cache[key] = reader.result;
        };
        e.target.value = "";
        return;
      }
      const maxCount =
        type === "detail" ? this.MAX_DETAIL_COUNT : this.MAX_COLOR_COUNT;
      const limitSize =
        type === "color" ? this.MAX_COLORCARD_SIZE : this.MAX_IMG_SIZE;
      const errMsg =
        type === "color" ? "图片大小不能超过1.3MB" : "图片大小不能超过1MB";
      const usedCount = this.getEffectiveFileCount(type);
      const remain = maxCount - usedCount;
      if (remain <= 0) {
        this.$message.error("图片已达上限5张");
        e.target.value = "";
        return;
      }
      const filesToAdd = fileList.slice(0, remain);
      if (filesToAdd.length < fileList.length) {
        this.$message.warning(
          `最多还能上传${remain}张，已自动截取前${remain}张`
        );
      }
      for (const file of filesToAdd) {
        if (!file.type.startsWith("image/")) {
          this.$message.error("存在非图片文件，已跳过");
          continue;
        }
        if (file.size > limitSize) {
          this.$message.error(`${file.name}: ${errMsg}，已跳过`);
          continue;
        }
        const freeIndex = this.getNextUploadIndex(type);
        if (freeIndex === -1) break;
        const key = `${type}-${freeIndex}`;
        this.uploadFiles[key] = file;
        delete this.imgBase64Cache[key];
        this.previewUrls[key] = URL.createObjectURL(file);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgBase64Cache[key] = reader.result;
        };
      }
      e.target.value = "";
    },
    getImagePreviewUrl(key) {
      return this.previewUrls[key] || this.imgBase64Cache[key] || "";
    },
    handleDeleteImage(type, index) {
      const key = `${type}-${index}`;
      if (this.previewUrls[key]) {
        URL.revokeObjectURL(this.previewUrls[key]);
      }
      delete this.uploadFiles[key];
      delete this.previewUrls[key];
      delete this.imgBase64Cache[key];
      delete this.draftImages[key];
      // 删除封面图，清空宽高
      if (type === "cover") {
        this.coverImageWidth = null;
        this.coverImageHeight = null;
      }
    },
    buildSubmitFormData(num) {
      const formData = new FormData();
      if (this.proid !== "") {
        formData.append("product.id", this.proid);
      }
      formData.append("product.flag", num);
      formData.append("product.outerKey", this.formData.productCode);
      if (this.formData.width)
        formData.append("product.width", this.formData.width);
      if (this.formData.weight)
        formData.append("product.weight", this.formData.weight);
      if (this.formData.composition)
        formData.append("product.ingredients", this.formData.composition);
      if (this.formData.categoryId.length !== 0) {
        this.formData.categoryId.forEach((item, index) => {
          formData.append(`product.categoryIds[${index}]`, item);
        });
      }
      if (this.formData.title)
        formData.append("product.title", this.formData.title);
      if (this.formData.content)
        formData.append("product.content", this.formData.content);
      if (this.formData.productpm)
        formData.append("product.name", this.formData.productpm);
      if (this.formData.yarnCount)
        formData.append("product.yarnCount", this.formData.yarnCount);
      if (this.formData.density)
        formData.append("product.density", this.formData.density);
      if (this.formData.quantify)
        formData.append("product.quantify", this.formData.quantify);
      if (this.formData.specification)
        formData.append("product.specification", this.formData.specification);
      if (this.formData.remark)
        formData.append("product.remark", this.formData.remark);

      // ---- 封面：修改/新增传 file，草稿未改传 id+url ----
      const coverKey = "cover-1";
      if (this.uploadFiles[coverKey]) {
        formData.append(
          "product.coverFile",
          this.uploadFiles[coverKey],
          this.uploadFiles[coverKey].name
        );
      } else if (this.draftImages[coverKey]) {
        formData.append("product.coverId", this.draftImages[coverKey].id);
        formData.append("product.coverUrl", this.draftImages[coverKey].url);
      }
      if (this.coverImageWidth != null) {
        formData.append("product.coverWidth", this.coverImageWidth);
      }
      if (this.coverImageHeight != null) {
        formData.append("product.coverHeight", this.coverImageHeight);
      }

      // ---- 详情图：新增/修改传 file，草稿未改传 id+sort ----
      const detailKeys = this.getAllImageKeys("detail");
      detailKeys.forEach((key, idx) => {
        const k = `particularsList[${idx}]`;
        if (this.uploadFiles[key]) {
          formData.append(`${k}.sort`, idx + 1);
          formData.append(
            `${k}.file`,
            this.uploadFiles[key],
            this.uploadFiles[key].name
          );
        } else if (this.draftImages[key]) {
          formData.append(`${k}.id`, this.draftImages[key].id);
          formData.append(`${k}.sort`, idx + 1);
        }
      });

      // ---- 色卡：新增/修改传 file，草稿未改传 id+sort ----
      const colorKeys = this.getAllImageKeys("color");
      colorKeys.forEach((key, idx) => {
        const k = `colorcardList[${idx}]`;
        if (this.uploadFiles[key]) {
          formData.append(`${k}.sort`, idx + 1);
          formData.append(
            `${k}.file`,
            this.uploadFiles[key],
            this.uploadFiles[key].name
          );
        } else if (this.draftImages[key]) {
          formData.append(`${k}.id`, this.draftImages[key].id);
          formData.append(`${k}.sort`, idx + 1);
        }
      });

      if (this.formData.coverMarks && this.formData.coverMarks.length) {
        formData.append(
          "product.coverFabricCoordinates",
          JSON.stringify(
            this.coverMarkList
              .filter((item) => item.type === "fabric")
              .map((item) => ({
                x: item.x,
                y: item.y,
              }))
          )
        );
        formData.append(
          "product.coverAccessoryCoordinates",
          JSON.stringify(
            this.coverMarkList
              .filter((item) => item.type === "accessory")
              .map((item) => ({
                x: item.x,
                y: item.y,
              }))
          )
        );
      }
      return formData;
    },
    async handlePublish(num) {
      if (
        !this.uploadFiles["cover-1"] &&
        !this.imgBase64Cache["cover-1"] &&
        num == 0
      ) {
        this.$message.error("封面图为必填项，请上传！");
        return;
      }
      if (!this.formData.productCode && num == 0) {
        this.$message.error("产品编号为必填项，请填写！");
        return;
      }
      if (this.formData.categoryId.length === 0 && num == 0) {
        this.$message.error("类别为必填项，请选择！");
        return;
      }
      const needReUpload = this.checkNeedReUpload();
      if (needReUpload) {
        this.$message.error("图片需要重新上传后才能发布！");
        return;
      }
      this.loading = true;
      try {
        const submitFormData = this.buildSubmitFormData(num);
        const res = await this.$api.Operation.UserProductlaunch.save(
          submitFormData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        console.log(res.data.code, "状态码是多少");
        if (res.data.code === "200") {
          if (num == 0) {
            this.proid = "";
            this.$message.success("发布成功!");
          } else {
            this.proid = "";
            this.$message.success("存入草稿成功!");
          }
          this.clearLocalCache();
          this.resetForm();
          this.getbh();
        } else {
          this.$message.error(res.data.msg || "发布失败，请重试");
          this.getbh();
        }
      } catch (error) {
        console.error("发布失败：", error);
        this.getbh();
        this.$message.error(
          `发布失败：${error.response.data.msg || "网络异常，请重试"}`
        );
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.clearPreviewUrls();
      this.formData = {
        productCode: "",
        width: "",
        weight: "",
        composition: "",
        categoryId: [],
        colorCardCode: "",
        title: "",
        content: "",
        productpm: "",
        specification: "",
        yarnCount: "",
        density: "",
        quantify: "",
        remark: "",
        flag: 0,
        coverMarks: [],
      };
      this.coverMarkList = [];
      this.uploadFiles = { "cover-1": null };
      this.uploadMaxIndex = { detail: 0, color: 0, cover: 1 };
      this.previewUrls = {};
      this.imgBase64Cache = {};
      this.coverImageWidth = null;
      this.coverImageHeight = null;
      this.isDraftMode = false;
      this.draftImages = {};
    },
    clearPreviewUrls() {
      Object.keys(this.previewUrls).forEach((key) => {
        if (this.previewUrls[key]) {
          URL.revokeObjectURL(this.previewUrls[key]);
        }
      });
    },
    getAllImageKeys(type) {
      const keys = new Set();
      Object.keys(this.uploadFiles).forEach((key) => {
        if (key.startsWith(`${type}-`)) {
          keys.add(key);
        }
      });
      Object.keys(this.imgBase64Cache).forEach((key) => {
        if (key.startsWith(`${type}-`)) {
          keys.add(key);
        }
      });
      return Array.from(keys).sort((a, b) => {
        const idxA = Number(a.split("-")[1]);
        const idxB = Number(b.split("-")[1]);
        return idxA - idxB;
      });
    },
    getNextUploadIndex(type) {
      for (let i = 1; i <= 5; i++) {
        const key = `${type}-${i}`;
        if (!this.uploadFiles[key]) {
          return i;
        }
      }
      return -1;
    },
    // 封面放大标注新增方法
    openCoverAnnotate() {
      const src = this.getImagePreviewUrl("cover-1");
      if (!src) {
        this.$message.warning("请先上传封面图");
        return;
      }
      this.coverAnnotateVisible = true;
      this.$nextTick(() => {
        this.initCoverCanvas(src);
      });
    },
    initCoverCanvas(imgSrc) {
      const canvas = this.$refs.coverCanvas;
      const wrap = this.$refs.canvasWrapRef;
      if (!canvas || !wrap) return;
      const ctx = canvas.getContext("2d");
      this.coverCanvas = canvas;
      this.coverCtx = ctx;
      this.coverScale = 1;
      this.coverTranslateX = 0;
      this.coverTranslateY = 0;
      this.coverIsDragging = false;
      this.coverImgObj = new Image();
      this.coverImgObj.src = imgSrc;
      this.coverImgObj.onload = () => {
        canvas.width = wrap.clientWidth;
        canvas.height = wrap.clientHeight;
        const img = this.coverImgObj;
        // 同步赋值原图宽高
        this.coverImageWidth = img.width;
        this.coverImageHeight = img.height;
        const scale = Math.min(
          canvas.width / img.width,
          canvas.height / img.height
        );
        this.coverScale = scale;
        this.coverTranslateX = (canvas.width - img.width * scale) / 2;
        this.coverTranslateY = (canvas.height - img.height * scale) / 2;
        this.drawCoverCanvas();
      };
      canvas.onwheel = (e) => {
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        const mx = e.clientX - rect.left;
        const my = e.clientY - rect.top;
        const delta = e.deltaY > 0 ? -0.1 : 0.1;
        const newScale = Math.max(0.2, Math.min(5, this.coverScale + delta));
        const ratio = newScale / this.coverScale;
        this.coverTranslateX = mx - (mx - this.coverTranslateX) * ratio;
        this.coverTranslateY = my - (my - this.coverTranslateY) * ratio;
        this.coverScale = newScale;
        this.drawCoverCanvas();
      };
      canvas.onmousedown = (e) => {
        this.coverIsDragging = true;
        this.coverLastX = e.clientX;
        this.coverLastY = e.clientY;
      };
      canvas.onmousemove = (e) => {
        if (!this.coverIsDragging) return;
        const dx = e.clientX - this.coverLastX;
        const dy = e.clientY - this.coverLastY;
        this.coverTranslateX += dx;
        this.coverTranslateY += dy;
        this.coverLastX = e.clientX;
        this.coverLastY = e.clientY;
        this.drawCoverCanvas();
      };
      canvas.onmouseup = () => {
        this.coverIsDragging = false;
      };
      canvas.onmouseleave = () => {
        this.coverIsDragging = false;
      };
    },
    drawCoverCanvas() {
      const canvas = this.coverCanvas;
      const ctx = this.coverCtx;
      const img = this.coverImgObj;
      if (!canvas || !ctx || !img) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      ctx.translate(this.coverTranslateX, this.coverTranslateY);
      ctx.scale(this.coverScale, this.coverScale);
      ctx.drawImage(img, 0, 0, img.width, img.height);
      // 区分两种点颜色：面料红色，辅料蓝色
      this.coverMarkList.forEach((mark) => {
        ctx.beginPath();
        ctx.arc(mark.x, mark.y, 6 / this.coverScale, 0, Math.PI * 2);
        ctx.fillStyle = mark.type === "fabric" ? "#f56c6c" : "#409eff";
        ctx.fill();
        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 2 / this.coverScale;
        ctx.stroke();
      });
      ctx.restore();
    },
    handleCanvasClick(e) {
      if (this.coverIsDragging) return;
      const canvas = this.coverCanvas;
      const img = this.coverImgObj;
      if (!canvas || !img) return;
      const rect = canvas.getBoundingClientRect();
      const cx = e.clientX - rect.left;
      const cy = e.clientY - rect.top;
      const originX = (cx - this.coverTranslateX) / this.coverScale;
      const originY = (cy - this.coverTranslateY) / this.coverScale;
      if (
        originX < 0 ||
        originY < 0 ||
        originX > img.width ||
        originY > img.height
      ) {
        return;
      }
      const targetType = this.currentMarkType;
      // 查找当前类型是否已经存在点
      const existIndex = this.coverMarkList.findIndex(
        (item) => item.type === targetType
      );
      const newPoint = {
        x: Math.round(originX),
        y: Math.round(originY),
        type: targetType,
      };
      if (existIndex > -1) {
        // 同类型已有点位，直接覆盖坐标
        this.coverMarkList.splice(existIndex, 1, newPoint);
      } else {
        // 该类型无点位，新增
        this.coverMarkList.push(newPoint);
      }
      this.drawCoverCanvas();
    },
    // 删除单个标记
    removeSingleMark(index) {
      this.coverMarkList.splice(index, 1);
      this.drawCoverCanvas();
    },
    clearCoverMarks() {
      this.coverMarkList = [];
      this.drawCoverCanvas();
    },
    clearCanvasInstance() {
      if (this.coverCanvas) {
        this.coverCanvas.onwheel = null;
        this.coverCanvas.onmousedown = null;
        this.coverCanvas.onmousemove = null;
        this.coverCanvas.onmouseup = null;
        this.coverCanvas.onmouseleave = null;
        this.coverCanvas = null;
        this.coverCtx = null;
      }
      this.coverImgObj = null;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./user-product-launch.scss";
.upload-box {
  position: relative;
}
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  label {
    width: 74px;
    text-align: right;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
    flex-shrink: 0;
  }
  input,
  ::v-deep .el-select {
    height: 32px;
    padding: 0 8px;
    border: none;
    border-bottom: 1px solid #999;
    border-radius: 4px;
    font-size: 14px;
  }
}
.single-item {
  width: 100%;
}
.fabric-group {
  margin-top: 56px;
  .group-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    font-weight: normal;
  }
}
.form-row {
  display: flex;
  .form-item {
    flex: 1;
    margin-bottom: 15px;
  }
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.publish-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.8;
}
.sort-ghost {
  background: #ecf5ff;
  border: 1px dashed #409eff;
}
.img-item {
  flex-shrink: 0;
  cursor: grab;
}
.img-item:active {
  cursor: grabbing;
}
.img-delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #f56c6c;
  color: #fff;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s;
}
.upload-box:hover .img-delete-btn {
  opacity: 1;
}
.uploaded-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
}
.file-input {
  display: none !important;
}
.canvas-wrap {
  canvas {
    cursor: crosshair;
    display: block;
  }
}
</style>
